import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { LeaveType } from '../types/leave';

interface LeaveTypesState {
  leaveTypes: LeaveType[];
}

const initialState: LeaveTypesState = {
  leaveTypes: [],
};

const leaveTypesSlice = createSlice({
  name: 'leaveTypes',
  initialState,
  reducers: {
    setLeaveTypes(state, action: PayloadAction<LeaveType[]>) {
      state.leaveTypes = action.payload;
    },
    addLeaveType(state, action: PayloadAction<LeaveType>) {
      state.leaveTypes.push(action.payload);
    },
    updateLeaveType(state, action: PayloadAction<LeaveType>) {
      const idx = state.leaveTypes.findIndex((lt) => lt.id === action.payload.id);
      if (idx !== -1) state.leaveTypes[idx] = action.payload;
    },
    removeLeaveType(state, action: PayloadAction<string>) {
      state.leaveTypes = state.leaveTypes.filter((lt) => lt.id !== action.payload);
    },
  },
});

export const { setLeaveTypes, addLeaveType, updateLeaveType, removeLeaveType } = leaveTypesSlice.actions;
export default leaveTypesSlice.reducer;
